<template>
  <h1 class="h1">{{ translations.Heading.HeadingH1 }}</h1>
  <h2 class="h2">{{ translations.Heading.HeadingH2 }}</h2>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeadingPort',
  computed: {
    ...mapState(['translations'])
  }
}
</script>

<style scoped>
.h1 {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
}
.h2 {
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: left;
  --tw-text-opacity: 1;
  color: rgba(34, 129, 196, var(--tw-text-opacity));
}
</style>
